<template>
  <div class="page-container">
    <div class="page-title-container d-flex justify-content-between align-items-center">
      <h1 class="page-title mb-0">Resultados: "{{ q }}"</h1>
      <b-button variant="none" class="button button-light" :to="{ name: 'ubigeo-departamentos' }">
        Volver
      </b-button>
    </div>

    <div class="table-container">
      <ubigeo-table-header :old-value="q" @reload="loadData()" />

      <div class="table-responsive mb-0 table-min-height">
        <table class="custom-table w-100">
          <thead>
            <tr>
              <th class="pl-3">Distrito</th>
              <th>Provincia</th>
              <th>Departamento</th>
              <th>Estado</th>
              <th class="pr-md-4">Acción</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="r in rows" :key="r.id">
              <td class="pl-3 font-weight-bold">{{ titleCase(r.distrito) }}</td>
              <td>{{ titleCase(r.provincia) }}</td>
              <td>{{ titleCase(r.departamento) }}</td>
              <td class="text-center">
                <span :class="`badge ${r.is_active ? 'badge-green' : 'badge-secondary'}`">
                  {{ r.is_active ? 'Activo' : 'Inactivo' }}
                </span>
              </td>
              <td class="text-center pr-md-3">
                <button class="button button-light" @click="goDistrito(r)">
                  Ver en provincia <i class="ri-arrow-right-line"></i>
                </button>
              </td>
            </tr>
            <tr v-if="!rows.length">
              <td colspan="5" class="text-center text-muted py-4">
                {{ q.length < 2 ? 'Escribe al menos 2 caracteres.' : 'Sin resultados.' }}
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</template>

<script>
import { Alert } from 'wize-admin'
import { UbigeoService } from '@/core/services'
import UbigeoTableHeader from '../Components/UbigeoTableHeader.vue'

export default {
  name: 'UbigeoSearch',
  components: { UbigeoTableHeader },
  data() {
    return { rows: [] }
  },
  computed: {
    q() { return (this.$route.query.q || '').trim() }
  },
  watch: {
    // Re-buscar si cambia el query (ej. nueva búsqueda desde el header).
    '$route.query.q'() { this.loadData() }
  },
  methods: {
    titleCase(s) {
      if (!s) return ''
      return String(s).toLowerCase().replace(/\b\w/g, (c) => c.toUpperCase())
    },
    goDistrito(r) {
      this.$router.push({
        name: 'ubigeo-distritos',
        params: { dept: r.departamento, prov: r.provincia }
      })
    },
    async loadData() {
      if (this.q.length < 2) { this.rows = []; return }
      try {
        await this.$store.dispatch('app/loading', true)
        const res = await UbigeoService.search(this.q)
        this.rows = res.payload || []
      } catch (e) {
        console.error(e)
        Alert.error(e.errors ? e.errors.message : 'Error en la búsqueda')
      } finally {
        await this.$store.dispatch('app/loading', false)
      }
    }
  },
  async mounted() {
    await this.loadData()
  }
}
</script>
